export default "__VITE_ASSET__SRRzDLfp__"